<div style="background-image: url('./assets/images/bg2020.jpg'); background-size: cover; height: 100% !important">
	<div class="theme-container">
		<mat-card [style.max-width.px]="500">
			<mat-card-header>
				<mat-card-title>Quick Release login</mat-card-title>
			</mat-card-header>
			<mat-card-content style="margin: 30px 10px 10px 10px">
				<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
					<div>
						<mat-form-field appearance="outline">
							<mat-icon matPrefix>group</mat-icon>
							<mat-label>Operator</mat-label>
							<input matInput type="text" formControlName="tenant" required (input)="uncheckTenant()" (blur)="checkTenant()" />
							<mat-error *ngIf="loginForm.controls.tenant.errors?.required">Tenant is required</mat-error>
							<mat-error *ngIf="loginForm.controls.tenant.errors?.invalidTenant">Tenant not found</mat-error>
							<mat-icon *ngIf="tenantId" matSuffix style="color: green">done</mat-icon>
						</mat-form-field>
					</div>
					<div>
						<mat-form-field appearance="outline">
							<mat-icon matPrefix>person</mat-icon>
							<mat-label>Email</mat-label>
							<input matInput type="text" formControlName="email" required />
							<mat-error *ngIf="loginForm.controls.email.errors?.required">Email is required</mat-error>
						</mat-form-field>
					</div>
					<div>
						<mat-form-field appearance="outline">
							<mat-icon matPrefix>lock</mat-icon>
							<mat-label>Password</mat-label>
							<input matInput type="password" formControlName="password" required />
							<mat-error *ngIf="loginForm.controls.password.errors?.required">Password is required</mat-error>
						</mat-form-field>
					</div>
					<div style="margin-top: 20px">
						<button mat-flat-button [disabled]="isDisabled || loginForm.invalid || !tenantId" style="width: 100%">
							<mat-icon class="text-muted">vpn_key</mat-icon>
							<span *ngIf="isDisabled" class="spinner-border spinner-border-sm"></span>
							Login
						</button>
					</div>
					<div style="display: flex; justify-content: center; align-items: center; font-size: x-small; margin-top: 5px">
						<p *ngIf="isDisabled" class="disabled">forgot password?</p>
						<a *ngIf="!isDisabled" href="javascript:;" (click)="onPasswordReset()">forgot password?</a>
					</div>
					<div style="display: flex; gap: 10px; margin-top: 20px">
						<mat-icon *ngIf="loginError" class="mat-error-icon">feedback</mat-icon>
						<span>{{ loginError | translate | capitalize }}</span>
						<mat-icon *ngIf="loginMessage" class="mat-accent-icon">info</mat-icon>
						<span>{{ loginMessage | translate | capitalize }}</span>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	</div>
</div>
